export { default as PendientesAnalisis } from "./modos/PendientesAnalisis";
export { default as PendientesValidacion } from "./modos/PendientesValidacion";
export { default as HistorialSolicitudes } from "./modos/HistorialSolicitudes";
